module.exports = __webpack_public_path__ + "img/graphic.cbf995b0.png";